import React, { useContext } from "react";
import { Fade } from "react-reveal";

import { GlobalContext } from "../../context/GlobalContext";

export default function Sidebar() {
  const { state, handleFunction } = useContext(GlobalContext);
  const { toggleSidebar } = state;
  const { sidebarClose } = handleFunction;

  return (
    <aside
      id="logo-sidebar"
      className={
        toggleSidebar === false
          ? "fixed top-0 max-2xl:left-0 2xl:left-[calc(50% - 500px)] pt-20 lg:pl-20 xl:pl-24 z-40 h-screen transition-transform -translate-x-full lg:translate-x-0"
          : "fixed top-0 left-0 z-40 w-1/2 h-screen pt-12 transition-transform lg:translate-x-0 transform-none"
      }
      aria-label="Sidebar"
      aria-hidden={toggleSidebar === false ? "true" : ""}
      aria-modal={toggleSidebar === false ? "" : "true"}
      role={toggleSidebar === false ? "" : "dialog"}
    >
      <Fade left>
        <div className="max-lg:pt-8 lg:pt-4 max-sm:pl-6 max-md:pl-8 max-lg:pl-12 h-full overflow-y-auto bg-mesanfaz-gray">
          <ul className="space-y-12 lg:space-y-8">
            <li>
              <a
                href="/about#profile"
                data-to-scrollspy-id="profile"
                onClick={sidebarClose}
              >
                🧑 profile
              </a>
            </li>
            <li>
              <a
                href="#experience"
                data-to-scrollspy-id="experience"
                onClick={sidebarClose}
              >
                💼 experience
              </a>
            </li>
            <li>
              <a
                href="#education"
                data-to-scrollspy-id="education"
                onClick={sidebarClose}
              >
                🏫 education
              </a>
            </li>
            <li>
              <a
                href="#training"
                data-to-scrollspy-id="training"
                onClick={sidebarClose}
              >
                📖 training
              </a>
            </li>
            <li>
              <a
                href="#skills"
                data-to-scrollspy-id="skills"
                onClick={sidebarClose}
              >
                💪 skills
              </a>
            </li>
          </ul>
        </div>
      </Fade>
    </aside>
  );
}
